import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import LessonItem from './LessonItem';
import { I18n } from 'react-redux-i18n-lite';

class ActivityBox extends Component {
  static propTypes = {
    withResults: PropTypes.any,
    activities: PropTypes.any,
    isTeacher: PropTypes.bool,
    contentsNotFound: PropTypes.bool,
    classroomId: PropTypes.string,
    classroom: PropTypes.any
  };

  getLessons() {
    const { activities, withResults, isTeacher, contentsNotFound, classroom } = this.props;

    if (!activities) {
      return contentsNotFound ? (
        <div className="activity-grades-container">{I18n.t('panels.assignment.contentTaskNotFound')}</div>
      ) : null;
    }

    return activities.map((unit, unitIndex) => {
      const unitName = Object.values(unit.name)[0];
      const lessonsWithActivities = unit.children.filter(lesson => lesson.children && lesson.children.length);

      return (
        <div key={`unit-${unitIndex}`}>
          <div className="lesson-unit-title">{unitName}</div>
          {lessonsWithActivities.map((lesson, lessonIndex) => (
            <LessonItem
              classroom={classroom}
              isTeacher={isTeacher}
              lesson={lesson}
              key={`${unitIndex}-${lessonIndex}`}
              withResults={withResults}
            />
          ))}
        </div>
      );
    });
  }

  render() {
    return <div className="activity-box-container">{this.getLessons()}</div>;
  }
}

function mapStateToProps(state, ownProps) {
  return {
    contentsNotFound: state.task.contentsNotFound,
    classroom: state.classrooms.activeClassrooms.find(c => c.id === ownProps.classroomId)
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityBox);
